export default __webpack_public_path__ + "static/media/1965.7291e214.png";